import { Colors } from '@sigma-frontend-libs/commons'

import { buttonModes, icons, services } from '@/utils'

import button from '@/components/button'
import draggable from '@/components/misc/draggable'
import { baseClass } from '@/components/rules/utils'
import rule from '@/components/services/tariffs/rules/rule'

function renderItem(h, item, index) {
  return h(
    rule, {
      props: {
        value: item,
        source: this.source,
        index
      },
      key: index,
      on: {
        input: event => {
          this.updateRule(index, event)
        },
        remove: event => {
          this.removeRule(event)
        }
      }
    }
  )
}
function renderItems(h) {
  if (this.proxy.length) {
    return h(
      draggable,
      {
        class: `${services.tariffs}-rules__items`,
        props: {
          value: this.proxy,
          handle: 'drag_handle'
        },
        on: {
          input: event => {
            this.proxy = event
          }
        },
        scopedSlots: {
          item: (item, index) => {
            return renderItem.call(this, h, item, index)
          }
        }
      }
    )
  }
}

function renderAddRuleButton(h) {
  return h(
    button,
    {
      props: {
        label: this.getTranslate(`${baseClass}.buttons.add.rule`),
        icon: icons.add,
        mode: buttonModes.flat,
        color: Colors.primary
      },
      on: {
        click: () => {
          this.add()
        }
      }
    }
  )
}
function renderFooter(h) {
  return h(
    'div',
    {
      class: `${services.tariffs}-rules__footer`
    },
    [ renderAddRuleButton.call(this, h) ]
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: `${services.tariffs}-rules`
    },
    [
      renderItems.call(this, h),
      renderFooter.call(this, h)
    ]
  )
}
